import gql from "graphql-tag";

import { Fragment, Skill } from "../types";
import { ReportAnswerFragment, REPORT_ANSWER_FRAGMENT } from "./ReportAnswer";

export const SKILL_FULL_FRAGMENT = gql`
  fragment SkillFullFragment on Skill {
    createdAt
    id
    kind
    locale
    name
    updatedAt
    reportAnswers {
      ...ReportAnswerFragment
    }
  }

  ${REPORT_ANSWER_FRAGMENT}
`;

export type SkillFullFragment = Fragment<
  Skill,
  Pick<Skill, "createdAt" | "id" | "kind" | "locale" | "name" | "updatedAt"> & {
    reportAnswers: ReportAnswerFragment[];
  }
>;
